import type { MOQRulesLookup } from '~/components/molecules/ProductDetails/useProductMOQLimits';
import type { MoqRuleApi } from '~/types/moqRulesApi.types';

/**
 * Convert API rules array to MOQRulesLookup Map
 * Returns an empty Map if no rules
 * @param rules - Array of MOQ rules from the API
 * @returns Map with target (SKU or brand name) as key
 */
export const convertApiRulesToLookup = (rules: MoqRuleApi[]): MOQRulesLookup => {
  if (!rules?.length) {
    return new Map();
  }

  return new Map(
    rules.map((rule) => [
      rule.target,
      {
        target: rule.target,
        type: rule.type,
        minQty: rule.minQty ?? undefined,
        maxQty: rule.maxQty ?? undefined,
      },
    ]),
  );
};
